import { TrendingUp, TrendingDown } from 'lucide-react';

import { fmtFixed } from '../../utils/format';
const TradingChart = ({ selectedPair = 'BTC/USDT', currentPrice = 43250.50 }) => {
  // Mock chart data for visualization
  const generateChartData = () => {
    const data = [];
    let price = currentPrice - 500;
    for (let i = 0; i < 50; i++) {
      price += (Math.random() - 0.48) * 100;
      data.push(price);
    }
    return data;
  };

  const chartData = generateChartData();
  const maxPrice = Math.max(...chartData);
  const minPrice = Math.min(...chartData);
  const priceChange = ((chartData[chartData.length - 1] - chartData[0]) / chartData[0]) * 100;

  return (
    <div className="glow-card p-4 sm:p-6 rounded-xl">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 sm:mb-6 gap-4">
        <div>
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-1">{selectedPair}</h3>
          <div className="flex items-center space-x-2 sm:space-x-4">
            <span className="text-2xl sm:text-3xl font-bold text-yellow-400">${currentPrice.toLocaleString()}</span>
            <span className={`flex items-center space-x-1 text-base sm:text-lg font-semibold ${priceChange >= 0 ? 'text-green-400' : 'text-red-400'}`}>
              {priceChange >= 0 ? <TrendingUp className="h-4 w-4 sm:h-5 sm:w-5" /> : <TrendingDown className="h-4 w-4 sm:h-5 sm:w-5" />}
              <span>{priceChange.toFixed(2)}%</span>
            </span>
          </div>
        </div>
        <div className="flex space-x-1 sm:space-x-2">
          {['1H', '4H', '1D', '1W', '1M'].map((timeframe) => (
            <button
              key={timeframe}
              className={`px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm rounded-lg font-semibold transition-all ${timeframe === '1D'
                  ? 'bg-purple-600 text-white'
                  : 'bg-gray-800 text-gray-400 hover:bg-gray-700'
              }`}
            >
              {timeframe}
            </button>
          ))}
        </div>
      </div>

      <div className="relative h-48 sm:h-64 md:h-80 bg-black/30 rounded-lg p-2 sm:p-4">
        <svg className="w-full h-full">
          <defs>
            <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#a855f7" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#a855f7" stopOpacity="0" />
            </linearGradient>
          </defs>
          <polyline
            fill="url(#chartGradient)"
            stroke="#a855f7"
            strokeWidth="2"
            points={chartData.map((price, index) => {
              const x = (index / (chartData.length - 1)) * 100;
              const y = 100 - ((price - minPrice) / (maxPrice - minPrice)) * 100;
              return `${x}%,${y}%`;
            }).join(' ')}
          />
        </svg>
        
        <div className="absolute top-2 right-2 text-right text-sm text-gray-400">
          <div>High: ${fmtFixed(maxPrice, 2)}</div>
          <div>Low: ${fmtFixed(minPrice, 2)}</div>
        </div>
      </div>
    </div>
  );
};

export default TradingChart;
